<template>
  <div>

    <template v-if="invoices.length">

      <div class="mb-2">
        <small class="muted">Deklaratsioonidega seotud klientide kinnitamata arved</small>
      </div>

      <b-form @submit.prevent="submit" novalidate>
        <b-form-radio-group id="radios2" v-model="selectedInvoiceId"
                            name="invoiceId" v-validate="'required'" :state="errors.has('invoiceId') ? false : null">

          <table class="table table-sm table-striped">
            <thead>
            <tr>
              <th></th>
              <th>Arve number</th>
              <th>Klient</th>
              <th>Summa</th>
              <th>Looja</th>
              <th>Loodud</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="invoice in invoices">
              <td>
                <b-form-radio :value="invoice.id"></b-form-radio>
              </td>
              <td>{{invoice.number}}</td>
              <td>{{invoice.clientName}}</td>
              <td>{{invoice.amount | amountWithCurrency}}</td>
              <td>{{invoice.createdBy}}</td>
              <td>{{invoice.createdAt | formatDate}}</td>
            </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col mt-3">
              <submit-button class="float-right" variant="primary">Lisa deklaratsioonid arvele</submit-button>
            </div>
          </div>

        </b-form-radio-group>
      </b-form>
    </template>

    <template v-else>
      <div>Valitud deklaratsioonide klientidel avatuid arveid ei ole</div>
      <b-button class="mt-2 float-right" type="button" variant="primary" @click="close">Sulge</b-button>
    </template>
  </div>
</template>

<script>
  import gateway from '@/services/gateway'

  export default {
    props: ['declarationIds'],
    data() {
      return {
        invoices: [],
        selectedInvoiceId: null
      }
    },
    methods: {
      loadInvoices() {
        gateway.post(`/invoices/suggest-for-declarations`, {declarationIds: this.declarationIds}).then(r => {
          this.invoices = r.data
        })
      },
      close() {
        this.$emit('cancel')
      },
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          gateway.post(`/invoices/${this.selectedInvoiceId}/add-declarations`, {declarationIds: this.declarationIds})
            .then(r => {
                this.$notifications.info('Deklaratsioonid lisatud arvele')
                this.$emit('done')
                this.$router.push(`/invoices/${this.selectedInvoiceId}`);
              }
            )
        })
      }
    },
    created() {
      this.loadInvoices()
    }
  }
</script>
